<template>
  <div>
    <div class="hpanel notranslate" id="search-box"  translate="no">
      <ul class="nav nav-tabs">
        <li class="active" id="tab-search-basic"><a data-toggle="tab" href="#tab-basic" @click="searchClicked"> Search</a></li>
        <li id="tab-search-advanced"><a data-toggle="tab" href="#tab-advanced" @click="advancedSearchClicked"> <i v-if="$user.isBasic() || !$user" class="fa fa-lock"></i> Advanced Search</a></li>
      </ul>
      <div class="tab-content">
        <div id="tab-basic" class="tab-pane active">
          <div class="panel-body">
            <div v-if="$user.isSe() && $user.isBasic() && $route.params && !$route.params.query" style="margin-bottom: 25px">
              <h3 class="text-center font-bold m-t m-b-md se-welcome-title" >
                Welcome to the LEA platform – the tool dedicated to Open Innovation
              </h3>
              <p class="text-center m-b se-welcome-title">
                <b>LEA</b> : <b>L</b>ook for <b>E</b>xpertise <b>A</b>ccess
              </p>
            </div>
            <form @submit="submitSearch" ref="formSearch">

              <div class="row">
                <div class="col-xs-12 col-sm-9 col-md-10 search-newSearch">
                  <simple ref="simple" v-model="query" :submitButton="submit"
                          :placeholder="searchInputPlaceholder"
                          :launchSearch="submitSearch" :history="true" :help-keywords="true"></simple>
                </div>
                <div id="dropdownTypeDocument" class="col-xs-6 col-xs-offset-3 col-sm-3 col-sm-offset-0 col-md-2">
                  <document-type-dropdown :buttonStyle="'width: 100%;padding-top: 10px;padding-bottom: 10px'"
                                          v-model="documentType" :buttonClass="''" :showLimitPlan="showLimitPlan"/>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div id="tab-advanced" class="tab-pane">
          <div class="panel-body">

            <form class="form-horizontal" @submit="submitSearchAdvanced">
              <advanced ref="advanced" v-model="queryAdvanced" :submitButton="submit" :defaultRangeDocumentValue="rangeDocumentValue" :sources="sources"
                        :defaultDocumentType="documentType" :suggestionsFilter="suggestionsFilter" :countType="countType"
                        :searchType="searchType" :showCountryFilter="showCountryFilter" :showSlider="showSlider"
                        :launchSearch="submitSearchAdvanced"></advanced>
            </form>

          </div>
        </div>
        <advanced-search-notification-box v-if="isAdvancedSearch === true" v-model="isAdvancedSearch"></advanced-search-notification-box>
        <div v-if="documentType === 'company' && companyNotification === true" class="alert-info p-xs">
          <div class="text-primary & text-center">
            <h3><i class="fa fa-exclamation-triangle fa-1x"></i> The service is temporarily limited, sorry for the inconvenience.</h3>
            <h4> <a @click="openSupport()" class="text-info"> Contact us </a> through the assistance in case of emergency.</h4>
          </div>
        </div>
      </div>
    </div>
    <researchAssistance v-if="researchAssistance" :query="query" @updateQuery="updateQuery"></researchAssistance>

    <welcome-free-trial-modal v-if="welcomeFreeTrial"></welcome-free-trial-modal>
  </div>
</template>

<style scoped>
.affix .nav {
  background-color: #f8f9fb;
}

</style>
<script>
import VueLadda from 'vue-ladda'
// import ResultSearchExpert from './test.js'
// import ResultSearchCompany from './company2.js'
// import ResultSearchPatents from './patent2.js'
// import ResultSearchExpertName from './expertName'
// import ResultSearchAster from './aster.js'
// import ResultSearchEdison from './edison.js'
// import ResultSearchBic from './bic.js'
import DocumentTypeDropdown from './DocumentTypeDropdown'
import ResearchAssistance from './ResearchAssistance'
import AdvancedSearchNotificationBox from './AdvancedSearchNotificationBox'
import WelcomeFreeTrialModal from '../../components/modal/WelcomeFreeTrialModal'
import Simple from './Simple'
import Advanced from './Advanced'
import {cleanQueryFromTagsinputToSearch} from '../../assets/scripts/search'
import History from './History'
import Search from '../Mixins/Search'

export default {
  mixins: [Search],
  components: {
    History,
    Advanced,
    Simple,
    AdvancedSearchNotificationBox,
    ResearchAssistance,
    VueLadda,
    DocumentTypeDropdown,
    WelcomeFreeTrialModal
  },
  name: 'SearchBox',
  props: ['value', 'showLimitPlan'],
  watch: {
    '$route' (to, from) {
      this.init()
    },
    value (value) {
      let factor = (value.authors.length && value.nbResults) ? (value.authors.length / value.nbResults) : 1
      this.tooManyResult = Math.round(factor * value.totalNbResults) >= 60000
    },
    documentType: function (val) {
      if (parseInt(val) !== 1) {
        this.sources.forEach((source) => {
          source.checked = source.label === 'default'
        })
      }
    }
  },
  data () {
    return {
      rangeDocumentValue: 120,
      sources: [{
        label: 'default',
        name: 'C_default',
        checked: true,
        details: '<span>Our recommended blend of data sources. We suggest using unless you have a specific reason.</span>'
      }, {
        label: 'c1',
        name: 'C_full',
        checked: false,
        details: '<span>Springer & generalist sources in Science, technology, and medicine with searching in titles, abstracts and full text.</span>'
      }, {
        label: 'c2',
        name: 'C_eng',
        checked: false,
        details: '<span>IEEE & Sources with strong focus on Engineering (Electrical, IT, Electronics, …); Searching in titles and abstracts.</span>'
      }, {
        label: 'c3',
        name: 'C_op',
        checked: false,
        details: '<span>Open Platform - Papers and conference proceedings, mixing various structured sources, we recommend to use by default as the most generalist source. Searching in titles and abstracts.</span>'
      }, {
        label: 'c4',
        name: 'C_fr',
        checked: false,
        details: '<span>HAL & Sources with high proportion of French papers and organisations; searching in titles and abstracts.</span>'
      }, {
        label: 'c5',
        name: 'C_gen',
        checked: false,
        details: '<span>Microsoft Academics & other generalist sources with search in title and abstracts.</span>'
      }, {
        label: 'c6',
        name: 'C_crossref',
        checked: false,
        details: '<span>Crossref (only super_admin)</span>'
      }, {
        label: 'c7',
        name: 'C_core',
        checked: false,
        details: '<span>Core (only super_admin)</span>'
      }, {
        label: 'c8',
        name: 'C_semantic',
        checked: false,
        details: '<span>Semantic Scholar (only super_admin)</span>'
      }],
      date: {
        from: null,
        to: null
      },
      advancedSearchName: {
        firstName: '',
        lastName: ''
      },
      documentType: this.getDocumentType(),
      showCountryFilter: false,
      showSlider: false,
      suggestionsFilterSelected: 'Filtered',
      searchTypeSelected: 'Keywords',
      countFilterSelected: 'Number of documents',
      suggestionsFilter: ['Filtered', 'Not filtered'],
      countType: ['Number of experts', 'Number of documents'],
      searchType: ['Keywords', 'Name'],
      searchCountries: [],
      query: '',
      queryAdvanced: '',
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      },
      isAdvancedSearch: false,
      cancelToken: null,
      cancelSearchSource: null,
      tooManyResult: false,
      searchInputPlaceholder: '',
      researchAssistance: false,
      welcomeFreeTrial: false,
      companyNotification: process.env.SHOW_COMPANY_WARNING
    }
  },
  methods: {
    activeTab: function (tab) {
      $('.nav-tabs a[href="#' + tab + '"]').tab('show')
    },
    advancedSearchClicked: function (e) {
      e.preventDefault()
      if (this.$user.isBasic()) {
        this.showLimitPlan()
        e.stopPropagation()
      } else {
        setTimeout(() => {
          this.showSlider = true
          this.showCountryFilter = true
        }, 200)
        this.queryAdvanced = this.$refs.simple.getQuery()
        this.$refs.advanced.documentType = this.documentType
      }

      if (!this.$user.isBasic()) {
        document.getElementById('suggestionsBox').style.display = 'none'
      }
    },
    searchClicked: function (e) {
      this.documentType = this.$refs.advanced.getDocumentType()
      this.query = this.$refs.advanced.getQuery()
      if (!this.$user.isBasic()) {
        document.getElementById('suggestionsBox').style.display = 'block'
      }
    },
    execSearch: function () {
      this.$emit('input', {
        authors: [],
        suggestions: [],
        totalNbResults: 0,
        nbResults: 0})

      this.submit.loading = true

      this.$emit('searchStateUpdate', 1)

      if (typeof this.$requestStack !== 'undefined') {
        this.$requestStack.flush()
      }

      if ($('#documentBox').length === 0) {
        $('html, body').animate({ scrollTop: $(document).height() }, 1000)
      } else {
        $('html,body').animate({
          scrollTop: $('#documentBox').offset().top - 190
        })
      }

      let queryData = this.getQueryData()

      this.$emit('searchTypeUpdate', {
        type: this.searchTypeSelected,
        firstName: this.advancedSearchName.firstName,
        lastName: this.advancedSearchName.lastName
      })

      this.$emit('queryUpdate', this.query)

      this.$emit('searchCountriesUpdate', queryData.countries)

      let debug = false

      if (debug === true) {
        // this.query = 'renewable energy'
        // let result = Object.assign(ResultSearchCompany)

        // this.$emit('searchStateUpdate', 1)

        // setTimeout(() => {
        //   this.$emit('searchStateUpdate', 2)
        // }, 500)
        // this.$emit('listTypeUpdate', 'company')

        // result = this.formatResult(result)

        // this.$emit('input', result)
        // this.submit.loading = false

        // if (this.$user.isSe() && this.documentType !== 'company') {
        //   this.getNbAsterCompany({'query': this.query, 'queryData': queryData })
        // }
      } else {
        this.$emit('listTypeUpdate', this.documentType)
        let query = cleanQueryFromTagsinputToSearch(this.query)
        let marketplace = false

        if (typeof this.$route.query.marketplace !== 'undefined') {
          marketplace = this.$route.query.marketplace
        }

        if (marketplace !== false) {
          query = query + '?marketplace=' + marketplace
        }

        this.$requestStack.add('post', '/search/' + query, queryData, 0)
          .then((response) => {
            this.$eventHub.$emit('queryChange', this.query)

            if ($('#documentBox').length === 0) {
              $('html, body').animate({ scrollTop: $(document).height() }, 1000)
            } else {
              $('html,body').animate({
                scrollTop: $('#documentBox').offset().top - 190
              })
            }

            if (response.data !== null && this.searchTypeSelected !== 'Name') {
              if ((this.documentType === 'science' || this.documentType === 'patents') &&
                (Object.values(response.data.authors).length <= 50 || Object.values(response.data.suggestions).length <= 5)) {
                this.researchAssistance = true
              } else if (this.documentType === 'company' && Object.values(response.data.authors).length <= 5) {
                this.researchAssistance = true
              }
            }
            let result = this.formatResult(response.data)

            this.$emit('input', result)
            if (typeof response.data.documents !== 'undefined' && response.data.nbResults !== 0) {
              this.$route.meta.empty = false
            }

            this.$salesMachine.newSearch({nbAuthors: result.authors.length, query: this.query, searchtype: this.documentType })

            this.$emit('searchStateUpdate', 2)
          })
          .catch((error) => {
            if (typeof error.response !== 'undefined' && error.response.data.status === 403) {
              this.$emit('errorQuotaUpdate', true)
            } else if (typeof error.response !== 'undefined' && error.response.data.status === 500 &&
              error.response.data.code === 503) {
              this.$notify({
                type: 'warning',
                title: 'Maintenance mode',
                content: 'We are going through a maintenance, your service will be back soon, sorry',
                placement: 'bottom-right',
                duration: 0
              })
            } else {
              this.submit.loading = false
              if (this.axios.isCancel(error)) {
                this.$notify({
                  type: 'warning',
                  title: 'Request canceled',
                  content: 'Following your request the search is stopped!',
                  placement: 'bottom-right'
                })
              } else {
                this.$notify({
                  type: 'warning',
                  title: 'An error has occurred',
                  content: 'We are sorry but we encountered an error, please refresh your page or try with another query!',
                  placement: 'bottom-right'
                })
              }
            }
            this.$emit('searchStateUpdate', 2)
          })
          .finally(() => {
            this.submit.loading = false
            if (this.$user.isFreeTrial() && !localStorage.getItem('welcomeFreeTrial')) {
              setTimeout(() => {
                localStorage.setItem('welcomeFreeTrial', true)
                this.welcomeFreeTrial = true
              }, 15000)
            }
          })
      }
    },
    getQueryData: function () {
      this.cancelToken = this.axios.CancelToken
      this.cancelSearchSource = this.cancelToken.source()
      return {
        sources: this.sources.filter((source) => {
          return source.checked === true
        }).map((source) => {
          return source.label
        }),
        nb_documents: this.rangeDocumentValue,
        date: this.date,
        document_type: this.documentType,
        search_type: this.searchTypeSelected,
        count_filter: this.countFilterSelected,
        suggestions_filter: this.suggestionsFilterSelected,
        countries: this.searchCountries,
        list_id: localStorage.getItem('listIdSelected'),
        cancelToken: this.cancelSearchSource.token,
        free_trial: localStorage.getItem('freeTrial') ? localStorage.getItem('freeTrial') : null
      }
    },
    submitSearch: function (e) {
      if (e !== null) {
        e.preventDefault()
      }

      if (this.query.length) {
        let queryData = this.getQueryData()

        this.setUrlWithAdvancedQuery(queryData)
      }
    },
    submitSearchAdvanced: function (e) {
      if (e !== null) {
        e.preventDefault()
      }
      this.query = this.$refs.advanced.getQuery()
      this.date = this.$refs.advanced.getDate()
      this.searchTypeSelected = this.$refs.advanced.getSearchTypeSelected()
      this.countFilterSelected = this.$refs.advanced.getCountFilterSelected()
      this.suggestionsFilterSelected = this.$refs.advanced.getSuggestionsFilterSelected()
      this.rangeDocumentValue = this.$refs.advanced.getRangeDocumentValue()
      this.searchCountries = this.$refs.advanced.getCountriesSelected()
      this.advancedSearchName = this.$refs.advanced.getAdvancedSearchName()
      this.documentType = this.$refs.advanced.getDocumentType()

      this.activeTab('tab-basic')
      this.submitSearch(e)
      document.getElementById('suggestionsBox').style.display = 'block'
    },
    initAdvancedQuery: function () {
      // this.clearAllParams()

      if (typeof this.$route.query._sources !== 'undefined') {
        let sources = this.$route.query._sources.split(';')
        this.isAdvancedSearch = true

        sources.forEach((querySource) => {
          let queryLabel
          switch (querySource) {
            case 's1':
              queryLabel = 'c1'
              break
            case 's2':
              queryLabel = 'c2'
              break
            case 's3':
              queryLabel = 'c3'
              break
            case 's4':
              queryLabel = 'c4'
              break
            case 's5':
              queryLabel = 'c5'
              break
            case 's6':
              queryLabel = 'c6'
              break
            case 's7':
              queryLabel = 'c7'
              break
            case 's8':
              queryLabel = 'c8'
              break
            default:
              queryLabel = querySource
              break
          }

          this.sources.forEach((source) => {
            if (source.label === queryLabel) {
              source.checked = true
            }
          })
        })
      }

      if (typeof this.$route.query.usedByCs !== 'undefined') {
        let usedByCs = this.$route.query.usedByCs.split(',')
        usedByCs.forEach((item) => {
          this.query += ',' + item
        })
      }

      if (typeof this.$route.query.nbResults !== 'undefined') {
        this.isAdvancedSearch = true
        let nbResults = parseInt(this.$route.query.nbResults)
        this.rangeDocumentValue = (nbResults < 0 || nbResults > 500) ? 120 : nbResults
      }

      if (typeof this.$route.query.daterange !== 'undefined') {
        this.isAdvancedSearch = true
        let daterange = this.$route.query.daterange.split('-')
        this.date.from = daterange[0]
        this.date.to = daterange[1]
      }

      if (typeof this.$route.query.unlimitedSuggestions !== 'undefined') {
        let unlimitedSuggestions = this.$route.query.unlimitedSuggestions
        this.suggestionsFilterSelected = unlimitedSuggestions === 'false' ? this.suggestionsFilter[0] : this.suggestionsFilter[1]
      }

      if (typeof this.$route.query.typeSearched !== 'undefined' && this.$route.query.typeSearched !== null) {
        let typeSearched = parseInt(this.$route.query.typeSearched)
        switch (typeSearched) {
          case 0:
            this.documentType = 'science'
            break
          case 1:
            this.documentType = 'patents'
            break
          case 3:
            this.documentType = 'company'
            break
          case 4:
            this.documentType = 'news'
            break
          case 5:
            this.documentType = 'aichat'
            break
        }
      }

      if (typeof this.$route.query._countries !== 'undefined') {
        this.isAdvancedSearch = true
        this.searchCountries = this.$route.query._countries.split(',')
      }
    },
    setUrlWithAdvancedQuery: function (queryData) {
      this.submit.loading = false

      let queryParams = this.prepareSearchWithAdvancedQuery(queryData)

      this.$router.push({ name: this.$route.name, params: {query: this.query}, query: queryParams })
    },
    init: function () {
      if (typeof this.$route.params.query !== 'undefined') {
        let query = this.$route.params.query

        this.query = decodeURIComponent(query)
        this.researchAssistance = false
        this.isAdvancedSearch = false
        this.initAdvancedQuery()
        this.initSearchByName()

        if (this.query !== null && this.query.length !== 0) {
          this.execSearch()
        }
      } else {
        this.$route.meta.empty = true
      }
    },
    getDocumentType: function () {
      let documentTypeValue = ['science', 'patents', 'science', 'company', 'news', 'aichat']
      let typeSearchedIndex = (typeof this.$route.query.typeSearched !== 'undefined' &&
        this.$route.query.typeSearched < 6) ? this.$route.query.typeSearched : 0

      return documentTypeValue[typeSearchedIndex]
    },
    cancelSearch: function () {
      this.$route.meta.empty = true
      this.cancelSearchSource.cancel('operation canceled by the user...')
    },
    initSearchByName: function () {
      if (this.query !== null && this.query.length) {
        let nameRegex = /name:"(.*)"/gm
        let queryName = nameRegex.exec(this.query)
        if (queryName !== null) {
          this.searchTypeSelected = this.searchType[1]

          let names = queryName[1].split(' ')
          this.advancedSearchName.lastName = names[names.length - 1]
          delete names[names.length - 1]
          this.advancedSearchName.firstName = ''
          if (names.length !== 0) {
            names.forEach((firstName) => {
              if (this.advancedSearchName.firstName.length === 0) {
                this.advancedSearchName.firstName = firstName
              } else {
                this.advancedSearchName.firstName += ' ' + firstName
              }
            })
          }
        } else {
          this.searchTypeSelected = this.searchType[0]
        }
      }
    },
    openSupport: function () {
      let iframe = document.getElementById('launcher')
      let supportButton = iframe.contentWindow.document.querySelector('#Embed button')

      if (typeof supportButton !== 'undefined') {
        supportButton.click()
      }
    },
    hashCode: function (s) {
      return s.split('').reduce(function (a, b) { a = ((a << 5) - a) + b.charCodeAt(0); return a & a }, 0)
    },
    formatResult: function (result) {
      if (this.documentType === 'news') {
        let suggestions = []
        let suggestionsTemp = []
        for (let [newsId, news] of Object.entries(result.news)) {
          result.news[newsId].id = parseInt(newsId) + 1
          result.news[newsId].hashId = this.hashCode(result.news[newsId].name)
          result.news[newsId].inBiblio = 0
          if (Object.keys(result.news).length < 20 || ((parseInt(newsId) + 1) / Object.keys(result.news).length < 0.34)) {
            result.news[newsId].score = 1
          } else if (((parseInt(newsId) + 1) / Object.keys(result.news).length) < 0.67) {
            result.news[newsId].score = 0.5
          } else {
            result.news[newsId].score = 0.1
          }
          if (result.news[newsId].about) {
            result.news[newsId].about.forEach((item) => {
              if (item.name !== this.query) {
                suggestionsTemp[item.name] = typeof suggestionsTemp[item.name] === 'undefined' ? 1 : (suggestionsTemp[item.name] + 1)
              }
            })
          }
        }

         if (Object.keys(suggestionsTemp).length > 0) {
          let trendCounter = 0
          for (let [kwd, key] of Object.entries(suggestionsTemp)) {
            if (trendCounter < 45) {
              suggestions.push({'name': kwd, 'score': key})
              trendCounter++
            }
          }
          suggestions.push({'name': this.query, 'score': 12})
        }
        return {
          authors: result.news,
          suggestions: suggestions,
          totalNbResults: result.totalNbResults,
          nbResults: Object.keys(result.news).length,
          localExperts: null
        }
      } else if (this.documentType === 'aichat') {
        let suggestions = []
        let resultTemp = [{ 'aichat': result.aichat, 'score': 1, 'inBiblio': 0 }]

        return {
          authors: resultTemp,
          suggestions: suggestions,
          totalNbResults: 1,
          nbResults: 1,
          localExperts: null
        }
      } else {
        let authors = Object.assign({}, result.authors)
        for (let [authorId, author] of Object.entries(authors)) {
          let organisationId = result.authorsOrganisations[authorId]

          if (typeof organisationId !== 'undefined') {
            authors[authorId].affiliation = result.organisations[organisationId]
          }
          authors[authorId].docs = []
          authors[authorId].topDocument = null
        }

        for (const [documentId, document] of Object.entries(result.documents)) {
          document.co_authors = []
          document.biblio = false
          for (const [authorId, score] of Object.entries(result.documentAuthors[documentId])) {
            let author = result.authors[authorId]
            document.co_authors.push({
              authorID: author.authorID,
              firstName: author.firstName,
              lastName: author.lastName,
              expertSource: author.expertSource,
              score: score,
              pos: (score === 1 ? 0 : (score === 1.5 ? 99999 : 1))
            })

            document.co_authors.sort((co1, co2) => {
              return co1.pos - co2.pos
            })

            document.newDocument = (typeof document.newDocument !== 'undefined') ? document.newDocument : false

            authors[authorId].docs.push(document)
          }
        }

        authors = Object.values(authors)

        authors.sort((author1, author2) => {
          return author2.score - author1.score
        })

        let documentsUsed = {}
        authors.forEach((author) => {
          author.docs.sort((doc1, doc2) => {
            let date1 = new Date(doc1.pubDate).getFullYear()
            let date2 = new Date(doc2.pubDate).getFullYear()
            return date2 - date1
          })

          let nbDocuments = author.docs.length
          for (let i = 0; i < author.docs.length; i++) {
            let document = author.docs[i]
            let firstAuthor = document.co_authors[0]
            let lastAuthor = document.co_authors[document.co_authors.length - 1]

            if (nbDocuments === 1 && (author.authorID === firstAuthor.authorID || author.authorID === lastAuthor.authorID)) {
              author.topDocument = document
              documentsUsed[document.documentID] = true
            } else if (typeof documentsUsed[document.documentID] === 'undefined') {
              author.topDocument = document
              documentsUsed[document.documentID] = true
            }

            if (author.topDocument !== null) {
              break
            }
          }

          author.display = author.topDocument !== null
        })
        return {
          authors: authors,
          suggestions: result.suggestions,
          totalNbResults: result.totalNbResults,
          nbResults: result.nbResults,
          localExperts: result.localExperts ? result.localExperts : null
        }
      }
    },
    updateQuery: function (query) {
      this.query = decodeURIComponent(query)
      this.researchAssistance = false
      this.isAdvancedSearch = false
      this.initAdvancedQuery()
      this.initSearchByName()

      if (this.query !== null && this.query.length !== 0) {
        this.submitSearch(null)
      }
    },
    clearAllParams: function () {
      this.isAdvancedSearch = false

      this.sources.forEach((source) => {
        source.checked = source.label === 'default'
      })

      this.rangeDocumentValue = 120
      this.date = {from: null, to: null}
      this.suggestionsFilterSelected = 'Filtered'
      this.searchTypeSelected = 'Keywords'
      this.countFilterSelected = 'Number of documents'
      this.documentType = 'science'
      this.searchCountries = []
      this.advancedSearchName = {firstName: '', lastName: ''}
    }
  },
  beforeMount () {
    if (this.$user.isSe() && this.$user.isBasic()) {
      this.searchInputPlaceholder = 'Enter search topics in English, e.g. image sensor'
    } else {
      this.searchInputPlaceholder = 'Enter search topics in English, e.g. image sensor'
    }
    this.init()
  },
  created () {
    this.$eventHub.$on('refineWithSuggestion', (suggestion) => {
      this.query += ',' + suggestion
      // this.queryToTags()
      // this.submitSearch(null)
    })
    this.$eventHub.$on('onlySearchSuggestion', (suggestion) => {
      this.query = suggestion
      // this.queryToTags()
      this.submitSearch(null)
    })
    this.$eventHub.$on('cancelSearch', (value) => {
      this.cancelSearch()
      this.query = this.query + ' '
    })
    this.$eventHub.$on('launchCompanySearch', (value) => {
      this.documentType = 'company'
      this.submitSearch(null)
    })
    this.$eventHub.$on('searchByName', (author) => {
      this.query = 'name:"' + author.firstName.replace(/\s/g, ' ').replace(/\./g, ' ').trim() + ' ' + author.lastName.trim() + '"'
      this.submitSearch(null)
    })
  },
  beforeDestroy () {
    this.$eventHub.$off('refineWithSuggestion')
    this.$eventHub.$off('onlySearchSuggestion')
    this.$eventHub.$off('cancelSearch')
    this.$eventHub.$off('launchCompanySearch')
    this.$eventHub.$off('searchByName')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/search/SearchBox.vue